import { useState, useEffect, memo, useRef } from 'react';

import { connect } from 'react-redux'
import { useHistory, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';

import { Box, Flex, Switch, Text, useToast } from '@chakra-ui/react';
import { CgTemplate } from "react-icons/cg";
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton.jsx';
import { createTemplateDsr } from '../../../digital-sales-room/actions/dsr-template-actions.js';
import DsrGenericLoadingModal from '../../../digital-sales-room/components/DsrGenericLoadingModal.jsx';
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers.js';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal.jsx';


function CreateDsrTemplateModal({
  handleCloseModal,
  modalTransferPayload,
  // Actions
  createTemplateDsr,
  // Redux states
  isMobileView,
  userAccountProfile,
  createDsrTemplateOutcome
}) {

  const initRef = useRef(false);
  const history = useHistory();
  const toast = useToast();

  // UX
  const [showLoader, setShowLoader] = useState(false);
  const orgNameDisplay = userAccountProfile ? userAccountProfile.orgName : "Team"

  // Local state
  const [localState, setLocalState] = useState({
    sourceDsrId: "",
    dsrTitle: "",
    isCopyFaq: true,
    isCopySharedDocs: true,
    isCopyPages: true,
    isOrgTemplate: true
  })


  useEffect(() => {
    if (modalTransferPayload && !initRef.current) {

      setLocalState(prevState => ({
        ...prevState,
        ...modalTransferPayload
      }))

      initRef.current = true
    }

  }, [modalTransferPayload])

  useEffect(() => {
    if (createDsrTemplateOutcome) {
      const { templateCreatedSuccessful, redirectUrl } = createDsrTemplateOutcome || {};

      const toastMetadata = {
        useCase: (templateCreatedSuccessful === true) ? "show-success-state" : "show-error-state",
        label: (templateCreatedSuccessful === true) ? "Template successfully created" : "Whoops! It's us, and something went wrong. Please try again later",
        isMobileView
      }


      if (!!templateCreatedSuccessful && redirectUrl) {
        history.push(redirectUrl, { toastMetadata })
      } else if (!templateCreatedSuccessful) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Whoops! It's us, and something went wrong. Please try again later",
            isMobileView
          })
        )
      }

      handleCloseModal()
    }
  }, [createDsrTemplateOutcome])


  const handleClickCreateTemplateButton = () => {
    setShowLoader(true)

    createTemplateDsr({
      event: 'create-template-dsr',
      sourceDsrId: localState.sourceDsrId,
      isCopyPages: localState.isCopyPages,
      isCopyFaq: localState.isCopyFaq,
      isCopySharedDocs: localState.isCopySharedDocs,
      isOrgTemplate: localState.isOrgTemplate
    })

  }


  const handleClickModalCloseButton = () => {
    handleCloseModal()
  }

  const renderContent = () => {
    if (showLoader) {
      return <DsrGenericLoadingModal modalText={`Creating the template ...`} />

    } else {
      return (<>
        <Flex w='100%' justify='center' mt='1em'>
          <Box as={CgTemplate} boxSize="3em" color="brand.500" />
        </Flex>
        <Box mt='1em' mb='2em' textAlign='center'>
          <Box fontSize='1.25em' fontWeight='600' color='brandDark.500' >Create a template using</Box>
          <Box fontSize='1em' color='gray.700' ml='0.25em' fontStyle={'italic'}> {localState.dsrTitle}</Box>
        </Box>


        <Box w="100%" align="center">

          <Flex w={isMobileView ? '100%' : '80%'} minW={!isMobileView && '30em'} direction='column' align='center' px='2em'>

            <Flex w='100%' my='1em'>

              <Flex justify='center' w='100%'>

                <Box w='100%' maxW={!isMobileView && '25em'} p={isMobileView ? '1em' : '1em 2em'} justify='center' rounded='0.25em' bg='gray.50' border='1px solid' borderColor='gray.300'>
                  <Text textAlign={'left'} mb='1em' fontSize='0.875em' fontWeight='600'>Include...</Text>
                  <Flex w='100%' direction='column' justify='center' align='center' gap={4}>

                    <Box mb='1em' w='100%'>
                      <Flex w='100%' justify='space-between' align='center'>
                        <Box fontSize='0.875em'>Customised Pages</Box>
                        <Box display='flex' fontSize='0.875em'>
                          <Box>
                            <Switch
                              size='lg'
                              name='isCopyPages'
                              isChecked={localState.isCopyPages}
                              value={localState.isCopyPages}
                              onChange={(event) => setLocalState({
                                ...localState,
                                isCopyPages: event.target.checked
                              })}
                            />
                          </Box>
                        </Box>

                      </Flex>
                      <Box textAlign='left' mt='0.2em' fontSize='0.6em' color='gray.500'>Duplicate all your pages & content in the template</Box>
                    </Box>

                    <Box mb='1em' w='100%'>
                      <Flex w='100%' justify='space-between' align='center'>
                        <Box fontSize='0.875em'>FAQ page</Box>
                        <Box display='flex' fontSize='0.875em'>
                          <Box>
                            <Switch
                              size='lg'
                              name='isCopyFaq'
                              isChecked={localState.isCopyFaq}
                              value={localState.isCopyFaq}
                              onChange={(event) => setLocalState({
                                ...localState,
                                isCopyFaq: event.target.checked
                              })}
                            />
                          </Box>
                        </Box>

                      </Flex>
                      <Box textAlign='left' mt='0.2em' fontSize='0.6em' color='gray.500'>All questions & answers copied into the template</Box>
                    </Box>

                    <Box mb='1em' w='100%'>
                      <Flex w='100%' justify='space-between' align='center'>
                        <Box fontSize='0.875em'>Shared Documents</Box>
                        <Box display='flex' fontSize='0.875em'>
                          <Box>
                            <Switch
                              size='lg'
                              name='isCopySharedDocs'
                              isChecked={localState.isCopySharedDocs}
                              value={localState.isCopySharedDocs}
                              onChange={(event) => setLocalState({
                                ...localState,
                                isCopySharedDocs: event.target.checked
                              })}
                            />
                          </Box>
                        </Box>

                      </Flex>
                      <Box textAlign='left' mt='0.2em' fontSize='0.6em' color='gray.500'>Same shared documents will be shared in the template</Box>
                    </Box>


                  </Flex>

                  <Text textAlign={'left'} mt='2em' mb='1em' fontSize='0.875em' fontWeight='600'>Access</Text>
                  <Flex w='100%' direction='column' justify='center' align='center' gap={4}>
                    <Box mb='1em' w='100%'>
                      <Flex w='100%' justify='space-between' align='center'>
                        <Box fontSize='0.875em'>Share with {orgNameDisplay}</Box>
                        <Box display='flex' fontSize='0.875em'>
                          <Box>
                            <Switch
                              size='lg'
                              name='isOrgTemplate'
                              isChecked={localState.isOrgTemplate}
                              value={localState.isOrgTemplate}
                              onChange={(event) => setLocalState({
                                ...localState,
                                isOrgTemplate: event.target.checked
                              })}
                            />
                          </Box>
                        </Box>

                      </Flex>
                      <Box textAlign='left' mt='0.2em' fontSize='0.6em' color='gray.500'>Let your co-workers use this template </Box>
                    </Box>
                  </Flex>
               
                </Box>


              </Flex>
            </Flex>

            <Flex justify='center' my='1em' py='0.625em'>
                    <LaunchdeckButton bg='brandDark.500' color='white' px='5em' label='Create template' onClick={() => handleClickCreateTemplateButton()} />
                  </Flex>
          </Flex>



        </Box>
      </>)

    }
  }


  return (
    <LaunchdeckModal
      // title=''
      handleCloseModal={handleClickModalCloseButton}
      showModal={true}
      maxW='35em'
    >
      {renderContent()}
    </LaunchdeckModal>
  )
}


const mapStateToProps = (state) => ({
  isMobileView: state.mobileViewMode.isMobileView,
  userAccountProfile: state.userProfile.accountUserProfile,
  createDsrTemplateOutcome: state.createDsrTemplateOutcome.results.data
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createTemplateDsr
    },
    dispatch,
  )


export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateDsrTemplateModal)))
